import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthLinkType } from '../../../../enums/event/event-data.enum';

@Component({
    selector: 'app-profile-confirmation-footer',
    templateUrl: './profile-confirmation-footer.component.html',
    styleUrls: ['./profile-confirmation-footer.component.scss'],
    standalone: false
})
export class ProfileConfirmationFooterComponent implements OnInit {
  @Input() isSubmitting = false;
  @Input() isSubmitted = false;
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();
  @Input() AuthLinkType = AuthLinkType;

  constructor() {}

  ngOnInit(): void {}

  confirmChange() {
    this.onConfirm.emit(true);
  }

  closeModal() {
    this.onCancel.emit(false);
  }
}
